








import Component, { mixins } from 'vue-class-component';
import { Prop } from 'vue-property-decorator';

import ImageMixin from '@/mixins/image';
import CookieMixin from '@/mixins/cookie';

@Component
export default class MinusButton extends mixins(ImageMixin, CookieMixin) {
  private fileName = 'estimate_icon_minus.png';

  emitEvent(): void {
    this.$emit('decrement');
  }
}
